import React from 'react';
import { 
  FaStar, 
  FaBolt, 
  FaFire, 
  FaMapMarkerAlt, 
  FaClock, 
  FaBriefcase,
  FaMedkit,
  FaGraduationCap,
  FaUsers,
  FaGlobe
} from 'react-icons/fa';
import './JobStatusBadges.css';

const JobStatusBadges = ({ status, jobType, location, isActive = true }) => {
  if (!isActive) return null;

  const badges = [];

  // Status badges based on the new API structure
  if (status) {
    if (status.featured) {
      badges.push({
        icon: <FaStar />,
        text: 'Featured',
        color: '#ffd700',
        type: 'featured'
      });
    }
    
    if (status.urgent) {
      badges.push({
        icon: <FaBolt />,
        text: 'Urgent',
        color: '#ff4d4d',
        type: 'urgent'
      });
    }
    
    if (status.hot) {
      badges.push({
        icon: <FaFire />,
        text: 'Hot',
        color: '#ff8c00',
        type: 'hot'
      });
    }
    
    if (status.remote) {
      badges.push({
        icon: <FaGlobe />,
        text: 'Remote',
        color: '#00cc88',
        type: 'remote'
      });
    }
    
    if (status.flexibleHours || status.flexible_hours) {
      badges.push({
        icon: <FaClock />,
        text: 'Flexible Hours',
        color: '#9c27b0',
        type: 'flexible'
      });
    }
    
    if (status.fullBenefits || status.full_benefits) {
      badges.push({
        icon: <FaMedkit />,
        text: 'Full Benefits',
        color: '#2196f3',
        type: 'benefits'
      });
    }
  }

  // Job type badge
  if (jobType) {
    badges.push({
      icon: <FaBriefcase />,
      text: jobType.charAt(0).toUpperCase() + jobType.slice(1).replace('_', ' '),
      color: '#4CAF50',
      type: 'jobType'
    });
  }

  // Location type badge
  if (location?.type) {
    const locationTypes = {
      remote: { icon: <FaGlobe />, text: 'Remote', color: '#00cc88' },
      hybrid: { icon: <FaMapMarkerAlt />, text: 'Hybrid', color: '#ff9800' },
      on_site: { icon: <FaMapMarkerAlt />, text: 'On-Site', color: '#795548' }
    };
    
    const locationType = locationTypes[location.type];
    if (locationType) {
      badges.push({
        ...locationType,
        type: 'location'
      });
    }
  }

  if (badges.length === 0) return null;

  return (
    <div className="job-status-badges">
      {badges.map((badge, index) => (
        <span 
          key={`${badge.type}-${index}`}
          className="status-badge"
          style={{ backgroundColor: badge.color }}
          title={badge.text}
        >
          {badge.icon} {badge.text}
        </span>
      ))}
    </div>
  );
};

export default JobStatusBadges; 